import { deepEqual, isArray, isEmptyString, isNil } from '../../util/object';
import MediaSegmentView from './MediaSegmentView';

export default class MediaSegmentEdit {
  _confidence = 0;
  _type = null;
  _views = [];

  /**
   * @typedef {Object} MediaSegmentEditWireObject
   * @param {number} confidence
   * @param {Array<MediaSegmentViewWireObject>} views
   */

  /**
   * @function
   * @param  {MEDIA_SEGMENT_EDIT_TYPE} mediaSegmentEditType
   * @param  {MediaSegmentEditWireObject} mediaSegmentEditWireObject
   * @return {MediaSegmentEdit}
   */
  constructor(mediaSegmentEditType, mediaSegmentEditWireObject) {
    if (isEmptyString(mediaSegmentEditType)) {
      return;
    }
    this._type = mediaSegmentEditType;
    if (isNil(mediaSegmentEditWireObject)) return;

    const { confidence, views } = mediaSegmentEditWireObject;
    this._confidence = confidence;
    if (isArray(views)) {
      views.forEach((viewWireObject) => {
        this._views.push(new MediaSegmentView(viewWireObject));
      });
    }
  }

  get confidence() {
    return this._confidence;
  }

  get type() {
    return this._type;
  }

  get views() {
    return this._views;
  }

  set views(views) {
    this._views = views;
  }

  equals(inputObject) {
    if (!MediaSegmentEdit.isMediaSegmentEdit(inputObject)) return false;

    return (
      this.confidence === inputObject.confidence &&
      this.type === inputObject.type &&
      deepEqual(this.views, inputObject.views)
    );
  }

  /**
   * Checks if object is an instance of MediaSegmentEdit
   *
   * @param inputObject
   * @returns {boolean}
   */
  static isMediaSegmentEdit(inputObject) {
    return inputObject instanceof MediaSegmentEdit;
  }
}
